import ProductsPage from "@bottlebooks/bottlebooks-site-base/src/components/ProductsPage/ProductsPage";
import { LoaderFunctionArgs, useLoaderData, useParams } from "react-router-dom";
import { z } from "zod";
import { bbCollectionIdSchema } from "~/bbCollectionIdSchema";
import { graphql } from "~/gql";
import { getFragment } from "~/gql-local/fragment-masking";
import graphQLClient from "~/graphQLClient";

const paramsSchema = z.object({
  locale: z.enum(["en", "de", "es", "fr"]),
  collectionId: z.string(),
});

const fragment = graphql(/* GraphQL */ `
  fragment ProductsPage on Event {
    eventId
    isProductSortingEnabled
    ...ProductsPageBase_Collection
    registeredProducts {
      nodes {
        ...ProductsPageBase
        productId
        # exhibitorId
        producerId
        registration {
          stand {
            name
          }
          profile {
            name
          }
        }
        product {
          shortName
          bottleImage {
            publicId
          }
          producer {
            name
            logo {
              publicId
            }
          }
        }
      }
    }
    registeredProducts {
      nodes {
        ...productFilters
      }
    }
  }
`);

type LoaderData = Awaited<ReturnType<typeof Loader>>;
export async function Loader({ params }: LoaderFunctionArgs) {
  const { locale, collectionId: collectionIdSegment } =
    paramsSchema.parse(params);
  const collectionId = bbCollectionIdSchema.parse(collectionIdSegment);
  const data = await graphQLClient.request(
    graphql(/* GraphQL */ `
      query ProductsPage($collectionId: ID!, $locale: ContentLocale) {
        event(eventId: $collectionId, locale: $locale) {
          ...ProductsPage
        }
      }
    `),
    {
      collectionId,
      locale,
    },
    { "bottlebooks-use-request-cache": "true" }
  );
  return data.event;
}

export default function ProductPageTemplate() {
  const parsed = paramsSchema.parse(useParams());
  const facets = useLoaderData() as LoaderData;
  const registeredProducts = getFragment(fragment, facets);
  // const event = getFragment(eventConfigurationFragment, cards);
  const products = registeredProducts?.registeredProducts?.nodes.map(
    (registeredProduct) => ({
      ...registeredProduct,
      ...registeredProduct.product,
      exhibitor: registeredProduct.registration.profile,
    })
  );
  if (!registeredProducts) return <div>No product found.</div>;
  return (
    <ProductsPage
      event={facets}
      products={products}
      locale={parsed.locale}
      // TODO: Not sure what this is
      location={"/"}
    />
  );
}
